import type {
  DeletableVertexContext,
  DeleteVertexContext,
} from '@/modules/Editor/plugins/edit/types'

export const isDeleteVertexContext = (c: DeletableVertexContext): c is DeleteVertexContext =>
  !!c && c.action === 'deleteVertex'
